import React from 'react';
//import { getBlockComponent } from '@benzinga/blocks';
import { CampaignifyBlock } from './Blocks/CampaignifyBlock';
import { OptimizelyCampaignifyBlock } from './Blocks/OptimizelyCampaignifyBlock';
import { MoneyBlock } from '@benzinga/money';
import { ArticleData } from '@benzinga/article-manager';
import type { Block as BlockInterface } from '@benzinga/content-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';

const Primis = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.Primis };
  }),
);

export interface PrimisArticleBlock extends BlockInterface {
  id: string;
}

export interface ArticleBlockProps {
  block: any;
  node?: ArticleData;
}

export interface CampaignifyPlaceholderBlock extends BlockInterface {
  position: string;
  nodeID: number | string;
}

export type ArticleBlockType = BlockInterface | PrimisArticleBlock | CampaignifyPlaceholderBlock;

export const ArticleBlock: React.FC<ArticleBlockProps> = props => {
  const block = getArticleBlock(props);
  return block ? block : <MoneyBlock {...props} type={'article-in-content'} />;
};

export const getArticleBlock = ({
  block,
}: // node,
ArticleBlockProps) => {
  if (block.blockName === 'ad/campaign') {
    return <div className="bz-campaign" dangerouslySetInnerHTML={{ __html: sanitizeHTML(block.value) }} />;
  } else if (block.blockName === 'ad/primis') {
    return <Primis id={block.id} placeholderId="primis-article-video" renderOnEvent selector="#primis-article-video" />;
  } else if (block.blockName === 'ad/campaignify') {
    return <CampaignifyBlock nodeID={block.nodeID} placeholderId={block.position} ticker={block.ticker} />;
  } else if (block.blockName === 'ad/optimizely-campaignify') {
    return <OptimizelyCampaignifyBlock nodeID={block.nodeID} placeholderId={block.position} />;
  }
  // return <p style={{ color: 'red' }}>{block.blockName}</p>;
  return null;
};
